export const PRIVACY_SHARING_OPT_OUT_STORAGE_KEY = 'optOutPrivacySharing'
